// extracted by mini-css-extract-plugin
export default {"accordion":"PsWEMs9txcuyq39_ssFn"};